import { Grid, Typography } from '@mui/material';
import { EmployeeResponse } from 'api/services/workforce/workforce-service.types';
import { useTranslation } from 'react-i18next';

type Props = {
  data: EmployeeResponse;
};

export const EmployeeInformationTab = ({ data }: Props) => {
  const { t } = useTranslation('all-platforms-common');
  return (
    <Grid item container xs={12} spacing={4} marginLeft={0}>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.first_name', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.firstName}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.infix', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.infix ?? '-'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.last_name', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.lastName}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.email', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.email}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.street', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.location?.street ?? '-'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.house_number', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.location?.houseNumber ?? '-'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.postal_code', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.location?.postalCode ?? '-'}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="subtitle1">
          {t('worker_data.city', { ns: 'all-platforms-common' })}
        </Typography>
        <Typography variant="body1">{data.location?.city ?? '-'}</Typography>
      </Grid>
    </Grid>
  );
};
